<template>
  <div class="h-full">
    <div class="hidden sm:block h-full">
      <portal-billing-proposal-vertical-timeline
        :available-steps="availableSteps"
        :current-step="currentStep"
      />
    </div>
    <div class="sm:hidden h-full">
      <portal-billing-proposal-horizontal-timeline
        :available-steps="availableSteps"
        :current-step="currentStep"
      />
    </div>
  </div>
</template>

<script>
import PortalBillingProposalVerticalTimeline from "./PortalBillingProposalVerticalTimeline.vue"
import PortalBillingProposalHorizontalTimeline from "./PortalBillingProposalHorizontalTimeline.vue"

export default {
  name: "ResponsiveTimeline",
  components: { PortalBillingProposalHorizontalTimeline, PortalBillingProposalVerticalTimeline },
  props: {
    currentStep: {
      type: Number,
      required: true,
    },
    availableSteps: {
      type: Array,
      required: true,
    },
  },
}
</script>
